module.exports = __webpack_public_path__ + "static/parade-2019-house07-7dc1748b6f4b66fdf7fb8198087bfc9e.jpg";